<template>
  <div class="pt-3">
    <v-container v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
                 v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
                 fluid>
      <v-row>
        <v-col cols="12" sm="7">
          <fin-lexicon-text :text="strategy.approach"
                            auto-solve
                            class="approach-desc"/>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import FinLexiconText from "@/components/common/lexicon/LexiconText"

export default {
  name: "finStrategyDetailsApproachTab",
  components: {FinLexiconText},
  props: {
    strategy: null,
  },
}
</script>

<style lang="scss" scoped>
.approach-desc {
  font-family: $body-font-family;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: $fin-color-primary-dark;
  /* additional */
  white-space: pre-line;
}
</style>
